"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _jsCookie = _interopRequireDefault(require("js-cookie"));

var _types = require("./types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var deleteAmplitudeCookie = () => {
  _jsCookie.default.remove(_types.COOKIE_KEYS.AMPLITUDE_SESSION_COOKIE_KEY, {
    domain: window.location.hostname
  });
};

var _default = deleteAmplitudeCookie;
exports.default = _default;
//# sourceMappingURL=deleteAmplitudeCookie.js.map